import { rem } from 'polished'
import styled, { withTheme } from 'styled-components'
import IconMagnifyingGlass from '../../../vectors/IconMagnifyingGlass'

const MagnifyingGlass = styled(IconMagnifyingGlass)`
  position: absolute;
  top: 51%;
  left: 5%;
  transform: translateY(-50%);
  width: ${rem('17px')};
  height: ${rem('16px')};
`

export default withTheme(MagnifyingGlass)
